import { OnInit, Component, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'djiv-nav-item',
    templateUrl: './djiv-nav-item.component.html',
    styleUrls: ["./djiv-nav-item.component.css"]
})
export class DJIVNavItem implements OnInit {
    @Input() routerLink: string;
    @Input() title: string;
    @Input() selected: string;

    constructor(private router: Router) { }

    ngOnInit() {}

    navigate() {
        this.router.navigateByUrl(this.routerLink);
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-nav-item/djiv-nav-item.component.ts